<template>
	<footer class="footer">
		<!-- 카드(호스트)별 안내 문장: 모든 페이지 공통 위치. 검색엔진 차별화용이며 kbprm 처럼 메뉴를 숨긴 호스트에도 표시한다. -->
		<div v-if="showFooterIntro" class="footer_intro">
			<div class="cont_center">
				<SiteIntro />
			</div>
		</div>
		<ul v-if="!isKbPrmHost" class="footer_menu">
			<li :key="item.footerMenu" v-for="item in footerMenu">
				<RouterLink :to="item.href" class="top_menu">
					<img :src="item.img" alt="" />
					{{ item.linkTitle }}
				</RouterLink>
			</li>
		</ul>

		<div class="cont_center">
			<div class="f_info">
				<div class="address_call">
					<p class="address">
						서울시 구로구 디지털로34길 43 코오롱싸이언스밸리1차 609,610호
						(주)브릿지엠
					</p>

					<p class="call">02.6407.8800</p>
				</div>

				<ul>
					<li>대표이사 : 서재필</li>
					<li>사업자등록번호 : 113-86-67636</li>
				</ul>
			</div>

			<p class="copyright">COPYRIGHT ⓒ 하이비타민. ALL RIGHTS RESERVED.</p>
		</div>
	</footer>
</template>

<script>
import { siteHostname } from "@/lib/Seo";
import { profileForHost } from "@/lib/siteProfiles";
import iconF1 from "@/assets/images/icon/icon_f1.png";
import iconF2 from "@/assets/images/icon/icon_f2.png";
import iconF3 from "@/assets/images/icon/icon_f3.png";
import iconF4 from "@/assets/images/icon/icon_f4.png";

export default {
	data() {
		const hostname = siteHostname();
		// 안내 문장이 없는 프로필이면 푸터 안내 줄 자체를 그리지 않는다 (kbprm·narasarang 은 심의 문구가 intro 라 그대로 보여 준다)
		const footerProfile = profileForHost(hostname);
		const showFooterIntro = Boolean(footerProfile.intro);
		const isKbPrmHost = hostname === "kbprm.hivitamin.co.kr";

		return {
			showFooterIntro,
			isKbPrmHost,
			footerMenu: [
				{
					img: iconF1,
					linkTitle: "브랜드 소개",
					href: "/HFO_HI_001",
				},
				// 청구할인 혜택 정리는 프로필 benefitGuide 호스트에만 노출 (메인 플로팅 버튼·FAQ 링크와 같은 기준)
				...(footerProfile.benefitGuide ? [{ img: iconF1, linkTitle: "복지카드 청구할인 혜택 정리", href: "/HFO_HI_002" }] : []),
				{
					img: iconF2,
					linkTitle: "이용약관",
					href: "/HFO_CO_004",
				},
				{
					img: iconF3,
					linkTitle: "개인정보처리방침",
					href: "/HFO_CO_003",
				},
				{
					img: iconF4,
					linkTitle: "제휴 문의",
					href: "/HFO_BI_003",
				},
			],
		};
	},
};
</script>
